export const setConsentedApps = (consentedApps) => ({
    type: "SET_CONSENTED_APPS",
    payload: consentedApps,
  });

// bootstrapMode = true quand l'utilisateur n'a aucune permission ET que le tenant
// n'est pas encore consenti (tenant neuf) → on doit proposer l'onboarding/consent.
export const setBootstrapMode = (bootstrapMode) => ({
  type: "SET_BOOTSTRAP_MODE",
  payload: bootstrapMode,
});